import { type Deployment } from '@composable/useWhiteLabel';

export const useDevice = () => {
    let deployment: Deployment = 'web';
    if (typeof process !== 'undefined' && process?.server) {
        deployment = (process.env.NUXT_PUBLIC_DEPLOYMENT ||
            'web') as Deployment;
    } else {
        const runtimeConfig = useRuntimeConfig();
        deployment = (runtimeConfig.public.deployment || 'web') as Deployment;
    }
    const layoutStore = useLayoutStore();
    const authStore = useAuthStore();
    const isAndroid = computed(() => deployment === 'android');
    const isIos = computed(() => deployment === 'ios');
    const isLegacyAndroid = computed(
        () => layoutStore.isWebApp && authStore.webAppSourceId === 19
    );
    const isLegacyIos = computed(
        () => layoutStore.isWebApp && authStore.webAppSourceId === 20
    );
    const isWebApp = computed(
        () => isIos.value || isAndroid.value || layoutStore.isWebApp
    );
    return {
        isIos,
        isAndroid,
        isWebApp,
        isLegacyAndroid,
        isLegacyIos,
    };
};
